export default {
  AUTHENTICATION_TOKEN_INVALID: 'authenticationTokenInvalid'
}
